import { FC } from 'react'
import { Switch, Redirect, useLocation } from 'react-router-dom'
import { useSelector } from 'utils/hooks'
import ErrorPage from 'components/global/ErrorPage'
import PrivateRoute from 'routes/PrivateRoute'

import routes from './config'

const Page403: FC = () => (
  <ErrorPage
    errorCode={403}
    title="403_title"
    description="403_description"
  />
)

const Page404: FC = () => (
  <ErrorPage
    errorCode={404}
    title="404_title"
    description="404_description"
  />
)

const AuthorisedRoutes: FC = () => {
  const { search } = useLocation()
  const employee = useSelector((s) => s.auth.employee)
  const company = useSelector((s) => s.auth.company)

  const isPermitted = (model: string): boolean => {
    let permitted = false
    if (
      model === 'Performance' &&
      !company?.subscribed_features?.includes('performance_management')
    ) {
      return false
    }

    if (employee?.permissions) {
      ;[
        ...employee.permissions,
        {
          module: 'Overview',
          value: 4,
        },
      ].forEach((permission) => {
        if (model === permission.module && permission.value > 0) permitted = true
      })
    }
    return permitted
  }

  return (
    <div>
      {employee?.permissions && (
        <Switch>
          {routes.map(({ path, permissionKey, component, isExact }, index) => (
            <PrivateRoute
              key={index}
              exact={isExact}
              path={path}
              component={isPermitted(permissionKey) ? component : Page403}
            />
          ))}
          <Redirect
            from="/login"
            to={{
              pathname: '/',
              search,
            }}
          />
          <PrivateRoute component={Page404} />
        </Switch>
      )}
    </div>
  )
}

export default AuthorisedRoutes
